// extracted by mini-css-extract-plugin
export default {"wrapper":"FrequentlyAskedQuestions_wrapper__qM1OS","container":"FrequentlyAskedQuestions_container__wUG2i","faqListWrapper":"FrequentlyAskedQuestions_faqListWrapper__H7Vm3"};